// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-more-images-container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.upload-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #1976d2;
  margin: 0 0 20px 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.stats {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.stat-success {
  color: #10b981;
  font-weight: 600;
  font-size: 14px;
}

.stat-error {
  color: #ef4444;
  font-weight: 600;
  font-size: 14px;
}

/* Dropzone */
.dropzone {
  border: 2px dashed #1976d2;
  border-radius: 12px;
  padding: 48px 24px;
  text-align: center;
  cursor: pointer;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.dropzone:hover {
  background: #e3f2fd;
  border-color: #1565c0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.dropzone-content {
  pointer-events: none;
}

.dropzone-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.dropzone-text {
  font-size: 18px;
  font-weight: 600;
  color: #1976d2;
  margin: 0 0 8px 0;
}

.dropzone-subtext {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* Table */
.table-container {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table thead {
  position: sticky;
  top: 0;
  background: #f8f9fa;
  z-index: 10;
}

.data-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  background: #f8f9fa;
}

.data-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  color: #4b5563;
}

.data-table tbody tr:hover {
  background: #f9fafb;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.url-cell {
  max-width: 400px;
}

.url-link {
  color: #1976d2;
  text-decoration: none;
  word-break: break-all;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.url-link:hover {
  text-decoration: underline;
  color: #1565c0;
}

.error-text {
  color: #ef4444;
  font-size: 13px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.status-badge.success {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.error {
  background: #fee2e2;
  color: #991b1b;
}

/* Progress Bar */
.progress-container {
  margin-top: 16px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #1976d2, #42a5f5);
  border-radius: 6px;
  transition: width 0.3s ease;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);
}

.progress-text {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* Buttons */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
}

.btn-primary {
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: white;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1565c0, #1976d2);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-upload,
.btn-export {
  width: 100%;
  padding: 16px;
  font-size: 18px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Scrollbar Styling */
.table-container::-webkit-scrollbar {
  width: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-section {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 12px;
  }

  .url-cell {
    max-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/UploadMoreImages.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".upload-more-images-container {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n}\n\n.upload-section {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n}\n\n.section-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1976d2;\n  margin: 0 0 20px 0;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.stats {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.stat-success {\n  color: #10b981;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.stat-error {\n  color: #ef4444;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Dropzone */\n.dropzone {\n  border: 2px dashed #1976d2;\n  border-radius: 12px;\n  padding: 48px 24px;\n  text-align: center;\n  cursor: pointer;\n  background: #f8f9fa;\n  transition: all 0.3s ease;\n}\n\n.dropzone:hover {\n  background: #e3f2fd;\n  border-color: #1565c0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);\n}\n\n.dropzone-content {\n  pointer-events: none;\n}\n\n.dropzone-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.dropzone-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1976d2;\n  margin: 0 0 8px 0;\n}\n\n.dropzone-subtext {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n}\n\n/* Table */\n.table-container {\n  max-height: 320px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.data-table thead {\n  position: sticky;\n  top: 0;\n  background: #f8f9fa;\n  z-index: 10;\n}\n\n.data-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  background: #f8f9fa;\n}\n\n.data-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #4b5563;\n}\n\n.data-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.url-cell {\n  max-width: 400px;\n}\n\n.url-link {\n  color: #1976d2;\n  text-decoration: none;\n  word-break: break-all;\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.url-link:hover {\n  text-decoration: underline;\n  color: #1565c0;\n}\n\n.error-text {\n  color: #ef4444;\n  font-size: 13px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.status-badge.success {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Progress Bar */\n.progress-container {\n  margin-top: 16px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 12px;\n  background: #e5e7eb;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #1976d2, #42a5f5);\n  border-radius: 6px;\n  transition: width 0.3s ease;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);\n}\n\n.progress-text {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n/* Buttons */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: none;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #1976d2, #42a5f5);\n  color: white;\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #1565c0, #1976d2);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n}\n\n.btn-upload,\n.btn-export {\n  width: 100%;\n  padding: 16px;\n  font-size: 18px;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Scrollbar Styling */\n.table-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .upload-section {\n    padding: 16px;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .data-table {\n    font-size: 12px;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 8px 12px;\n  }\n\n  .url-cell {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
